import { createSelector } from 'reselect';
import { IApplicationState } from "./../../../../src/~store/models/ApplicationState";

const mailingSelector = (state: IApplicationState) => state.mailingState;

export const allMailingsSelector = createSelector(
    mailingSelector, 
    mailingState => mailingState.mailingList.allMailings.sort((a, b) => 
        b.mailingId - a.mailingId
    )
);

export const isReceivingMailingsSelector = createSelector(
    mailingSelector, 
    mailingState => mailingState.mailingList.isReceivingmailings
);

export const isAllLoadedSelector = createSelector(
    mailingSelector,
    mailingState => mailingState.mailingList.isAllLoaded
);

//mailingItemInfo
export const mailingItemInfoSelector = createSelector(
    mailingSelector, 
    mailingState => mailingState.mailingItemInfo.mailing
);

export const mailingRecipientsSelector = createSelector(
    mailingSelector, 
    mailingState => mailingState.mailingItemInfo.recipients
);

export const isReceivingRecipientsSelector = createSelector(
    mailingSelector,
    mailingState => mailingState.mailingItemInfo.isReceivingRecipients
);

export const channelsIdsSelector = createSelector(
    mailingSelector, 
    mailingState => mailingState.mailingItemInfo.mailing.channelsIds
);

export const enabledChannelsSelector = createSelector(
    mailingSelector, 
    mailingState => mailingState.mailingItemInfo.enabledChannels
);



